import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $accountSettignsModalTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('modal_window_to_account_settings'),
  buttonTitle: t('button_go_to_account_settings'),
}))
